export const availableLocale = [
  {
    text: "Việt Nam",
    value: "vi",
    img: require("@/assets/flags/Vietnam-Flag.svg"),
  },
  {
    text: "English",
    value: "en",
    img: require("@/assets/flags/united-states.svg"),
  },
  {
    text: "Français",
    value: "fr-FR",
    img: require("@/assets/flags/france.svg"),
  },
  {
    text: "Русский",
    value: "ru-RU",
    img: require("@/assets/flags/germany.svg"),
  },
  {
    text: "日本語",
    value: "ja-JP",
    img: require("@/assets/flags/japan.svg"),
  },
];
export default {
  locale: "vi",
};
